import React from "react";
import { createRoot } from "react-dom/client";

import I18nProvider from "./components/I18nProvider";
import PdfGenerator from "./components/PdfGenerator";
import "./i18n";
import "./styles/main.css";
import "./styles/tailwind.css";

// Point d'entrée de l'application React pour l'intégration PHP
const App = () => {
  return (
    <I18nProvider>
      <PdfGenerator />
    </I18nProvider>
  );
};

// Initialiser l'application React
document.addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById("root");
  if (!container) {
    console.error("Element #root not found");
    return;
  }

  const root = createRoot(container);
  root.render(<App />);
});

// Gestion des erreurs globales
window.addEventListener("error", (event) => {
  console.error("Erreur globale:", event.error);
});

window.addEventListener("unhandledrejection", (event) => {
  console.error("Promise rejetée:", event.reason);
});
